import React from 'react'
import SectionTechnical from './Sections/SectionTechnical'

const TechnologyPage = () => {
    return (
        <div className="container pt-5">
            <div className="row mt-5 pt-5">
                <SectionTechnical/>
            </div>
            
        </div>
    )
}

export default TechnologyPage
